import React, { useState } from "react";
import {
	Modal,
	Box,
	Typography,
	TextField,
	Button,
	CircularProgress,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import Agency from "../../../interfaces/agency";
import DropDownValue from "../../baseComponents/dropdownvalue";

interface AddHuntGroupModalProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (newTemplateRequest: NewHuntGroupRequest) => void;
}

const modalStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	borderRadius: 2,
};

export interface NewHuntGroupRequest {
	huntGroupName: string,
	selectedAgency: string
}

const AddHuntGroupModal: React.FC<AddHuntGroupModalProps> = ({ open, onClose, onSubmit }) => {
	// Form State
	const [huntGroupName, setHuntGroupName] = useState("");
	const [selectedAgency, setSelectedAgency] = useState<string>("");

	// Data State
	const agencies: Agency[] = useSelector((state: RootState) => state.agencies.agencies);

	const [loading, setLoading] = useState<boolean>(false);

	const handleClose = () => {
		// Reset state on close
		setHuntGroupName("");
		setSelectedAgency("");
		onClose();
	};

	const handleSubmit = () => {
		setLoading(true);
		if (huntGroupName.length > 0 && selectedAgency) {
			onSubmit({
				huntGroupName: huntGroupName,
				selectedAgency: selectedAgency
			})
		} else {
			alert("All fields are mandatory");
		}
		setLoading(false);
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box sx={modalStyle}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
					<Typography variant="h6">Add New Hunt Group</Typography>
					<IconButton onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Box>

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
					<TextField
						label="Hunt Group Name"
						variant="outlined"
						fullWidth
						value={huntGroupName}
						onChange={(e) => setHuntGroupName(e.target.value)}
					/>

					<DropDownValue
						label="Select Agency"
						items={agencies}
						selectedValue={selectedAgency}
						onSelection={(e: string) => setSelectedAgency(e)}
						keyProp="agency_name"
						valueProp="agency_name"
						displayProp="agency_name"
					/>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button onClick={handleClose} sx={{ mr: 2 }}>Cancel</Button>
						<Box mt={2} textAlign="right">
							<Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
								{loading ? <CircularProgress size={24} /> : "Add Hunt Group"}
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};

export default AddHuntGroupModal;